import { Company } from "../../company/company.model";

export class ProfileChangeData {
  companies: Company;
}